
.inputContainer {
  width: 100%;
  color: var(--static-text-standard);
  background: var(--static-background-standard);
  border-radius: 8px;
  padding: 0 1ch;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--static-divider-standard);
}

.inputContainerInvalid {
  border: 1px solid var(--sentiment-text-negative);
}
.inputContainerReadonly {
  opacity: 0.6;
  background-color: var(--static-background-weak);

  .input {
    cursor: not-allowed;
  }
}
.inputContainerDisabled {
  opacity: var(--field-opacity-disabled);
  color: var(--field-text-disabled);
  background: var(--field-background-disabled);

  .input {
    cursor: not-allowed;
  }
}
.inputCenter {
  text-align: center !important;
}

.borderless {
  border: none;
}

.input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.input[type=number] {
  -moz-appearance: textfield;
}

.input {
  all: unset;
  outline: revert;
  width: 100%;
  font: inherit;
  box-sizing: border-box;
  min-height: 2rem;
  outline: 0;
}

.input:focus, input:hover {
  cursor: text;
}
input:disabled {
  cursor: not-allowed;
}

.inputContainer:not(.inputContainerReadonly):focus-within {
  border-color: var(--primary-enabled);
}

.prefix {
  margin-right: 4px;
  align-items: center;
  display: flex;
}
.suffix {
  margin-left: 4px;
  align-items: center;
  display: flex;
}
